/**
 * Причина ошибки загрузки скрипта Яндекс карт:
 * stub — блокировщик (например, Анти-Баннер Касперского) подменил скрипт на картинку,
 * offline — у пользователя нет сети, unknown — не удалось определить
 */
export type TYmapsScriptLoadErrorReason = 'stub' | 'offline' | 'unknown';

/** Сколько ждём проверку картинкой, прежде чем считать причину неизвестной */
export const YMAPS_STUB_DETECT_TIMEOUT = 3_000;

/**
 * Определяет причину ошибки загрузки скрипта Яндекс карт.
 * Блокировщики подменяют ответ на прозрачный gif 1x1:
 * если тот же URL успешно грузится как картинка, значит вместо скрипта пришла заглушка.
 * Настоящий JS картинкой не декодируется и попадёт в onerror.
 *
 * Без async/await и зависимостей: используется в инлайн-загрузчике карты
 */
export function detectYmapsScriptLoadErrorReason(
  src: string | undefined,
  callback: (reason: TYmapsScriptLoadErrorReason) => void,
) {
  if (navigator.onLine === false) {
    callback('offline');

    return;
  }

  if (!src) {
    callback('unknown');

    return;
  }

  let isDone = false;
  const done = (reason: TYmapsScriptLoadErrorReason) => {
    if (!isDone) {
      isDone = true;
      callback(reason);
    }
  };

  const img = new Image();
  img.onload = () => done(img.naturalWidth <= 1 && img.naturalHeight <= 1 ? 'stub' : 'unknown');
  img.onerror = () => done('unknown');
  img.src = src;

  setTimeout(() => done('unknown'), YMAPS_STUB_DETECT_TIMEOUT);
}

/**
 * URL скрипта Яндекс карт, вставленного на страницу.
 * Нужен, когда скрипт вставляет сторонний пакет и не отдаёт его URL в колбек ошибки
 */
export function findYmapsScriptSrc(): string | undefined {
  const script = document.querySelector<HTMLScriptElement>('script[src*="api-maps.yandex.ru"]');

  return script?.src || undefined;
}
